<template>
  <div>
    <div class="cable-select" v-on:click="open_modal">
      <select
        :value='value'
        class='cable-select'
        @mousedown="mousedown"
        @input="input"
        @click='select_clicked'
        style='cursor: pointer'
      >
        <option value='' disabled selected='selected' data-default>Select your camera model...</option>
        <option
          v-for='camera in supported_cameras'
          :value='`${camera.brand} ${camera.model} - ${camera.cable}`'>
          {{`${camera.brand} ${camera.model_formatted} - ${camera.cable}`}}
        </option>
      </select>
    </div>

    <transition name="modal">
      <div class="modal-wrapper" v-if="show">
        <div class="modal what-camera-modal">
          <div v-show="!showDropzone">
            <div class="modal-body">
              <h3>Select your camera</h3>

              <div class="form-group">
                <label for="camera-brand" style="font-weight: bold; margin-bottom: 4px; display: block">Camera Brand</label>
                <select id="camera-brand" class="form-control" v-model="brand" @change="select_brand">
                  <option value='' disabled selected='selected' data-default>Select your camera brand...</option>
                  <option v-for='brand in supported_brands' :value='brand'>{{ brand }}</option>
                </select>

                <div class="error form-error" v-if="errors.brand">{{ errors.brand }}</div>
              </div>

              <!-- Select camera model -->
              <div v-if="brand" class="form-group">
                <label for="camera-model" style="font-weight: bold; margin-bottom: 4px; display: block">Camera Model</label>
                <select id="camera-model" class="form-control" v-model="model" @change="select_model">
                  <option value='' disabled selected='selected' data-default>Select your camera model...</option>
                  <option v-for='model in models' :value='model'>
                    {{ supported_cameras.find(camera => camera.model === model).model_formatted }}
                  </option>
                </select>

                <div class="error form-error" v-if="errors.model">{{ errors.model }}</div>
              </div>

              <a v-if='can_identify_camera' @click.prevent='showDropzone = true'>Not sure what camera you have?</a>
            </div>

            <div class="modal-actions">
              <a @click.prevent='close_modal' class='btn btn-cancel'>Cancel</a>
              <a @click.prevent='select' class='btn btn-primary'>Select</a>
            </div>
          </div>

          <div v-show="showDropzone">
            <WhatCamera
              :close_modal="close_modal"
              :supported_brands="supported_brands"
              :supported_cameras="supported_cameras"
              @select="what_camera_select"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import all_cameras from 'app/cameras.json'
import WhatCamera from 'app/components/shared/WhatCamera'
import includes from 'lodash/includes'

  export default {
    components: { WhatCamera },
    props: ['arsenal_version', 'value', 'variant'],
    data () {
      return {
        show: false,
        showDropzone: false,
        brand: '',
        model: '',
        models: [],
        errors: {
          brand: null,
          model: null
        }
      }
    },
    mounted() {
      if (this.value) {
        const brandAndModel = this.value.split(' - ')[0]
        this.brand = brandAndModel.split(' ')[0]
        this.select_brand()
        this.model = brandAndModel.split(' ').slice(1).join(' ')
      }
    },
    computed: {
      // The photo-based camera identifier is for Arsenal 2 only (not the Arsenal 1 cable page)
      can_identify_camera() {
        return Number(this.arsenal_version) !== 1
      },
      supported_brands() {
        const brands = this.supported_cameras.map(camera => camera.brand)
        return [...new Set(brands)]
      },
      supported_cameras() {
        let supported_cameras = []

        Object.keys(all_cameras).forEach(brand => {
          all_cameras[brand].forEach(camera => {
            if (includes(camera.arsenal_support, this.arsenal_version)) {
              supported_cameras.push(camera)
            }
          })
        })

        return supported_cameras
      },
    },
    methods: {
      input(event) {
        return
      },
      mousedown(event) {
        event.preventDefault()
      },
      open_modal() {
        this.show = true
      },
      close_modal(force = false) {
        if (this.showDropzone) {
          this.showDropzone = false
          if (force) this.show = false
          return
        }
        this.show = false
      },
      select_brand() {
        this.model = ''
        this.models = this.supported_cameras.filter(camera => camera.brand === this.brand).map(camera => camera.model)
        if (this.errors.brand || this.errors.model) this.validate()
      },
      select_model() {
        if (this.errors.brand || this.errors.model) this.validate()
      },
      what_camera_select({ brand, model }) {
        this.brand = brand
        this.select_brand()
        this.model = model
        this.select()
        this.close_modal(true)
      },
      validate() {
        this.errors.brand = null
        this.errors.model = null

        if (!this.brand) {
          this.errors.brand = 'Brand is required'
        }
        if (!this.model) {
          this.errors.model = 'Model is required'
        }
      },
      select() {
        this.validate()
        if (this.errors.brand || this.errors.model) return

        const camera = this.supported_cameras.find(item => item.brand === this.brand && item.model === this.model)
        this.$emit('input', `${camera.brand} ${camera.model} - ${camera.cable}`)
        this.close_modal()
      },
      select_clicked () {
        if (typeof gtag !== 'undefined') {
          gtag('event', 'order form list of cameras viewed', { event_category: 'interactions' })
        }
        const eventID = document.querySelector('meta[name="request_id"]').getAttribute('content')

        if (typeof fbq !== 'undefined') {
          fbq('trackCustom', 'ViewedCamerasList', {}, { eventID })
        }

        this.$http.post('/orders/viewed_cameras_list', { event_id: eventID }).then(r => {}, r => {})
      }
    }
  }
</script>
